'use strict';

import Ease from './Ease';



class SmoothScroll {
	constructor(){
		this.scrollEl = ()=>{
			if('scrollingElement' in document) return document.scrollingElement;
			if(navigator.userAgent.indexOf('WebKit') != -1) return document.body;
			return document.documentElement;
		};
		this.duration = {
			normal: 500,
			fast: 100
		};
	}

	render(els, offset=0){
		$.each(document.querySelectorAll(els), (i, el)=>{
			let anc = el.getAttribute('href');
			el.addEventListener('click', (e)=>{
				e.preventDefault();
				this.scroll(anc, offset);
			}, false);
		});
	}

	scroll(anc, offset=0, speed='normal'){
		let target = document.querySelector(anc);
		if( !target ) return;
		let pos = app.Util.offset(target).top - offset;

		pos -= ( 1023 <= app.Util.ww() )? app.Util.fontsize()*7 : app.Util.fontsize()*6;

		pos = ( pos < 0 )? 0 : pos;
		$('html, body').stop().animate({scrollTop:pos}, 500, app.Config.ease.tween);
	}
};

export default new SmoothScroll();




// class SmoothScroll {
// 	constructor(){
// 	}

// 	render(el){
// 		$(document).on('click', el, (e)=>{
// 			let target = $(e.currentTarget).attr('href');
// 			this.scroll(target);
// 			return false;
// 		});
// 	}

// 	scroll(target, offset=85){//offset=40
// 		app.Header.close();
// 		let pos = $(target).offset().top;

// 		console.log(pos);
// 		// pos -= ( app.Util.layoutType() == 'SP' )? offset : offset;
// 		// pos -= $('#header').outerHeight();
// 		pos -= 5*app.Util.fontsize();
// 		if( pos < 0 ) pos = 0;
// 		$('html, body').animate({scrollTop:pos}, 500, app.Config.ease.tween);
// 	}

// };

// export default new SmoothScroll();
